import $ from 'jquery';
import Modal from '../modules/Modal'
import Form from '../modules/Form'

class NomadKitchens extends Form{

    constructor(){

        super();

        this.form = $('#nomad-kitchens-contact-form');

        this.button = this.form.find('#contact-submit-button');

        this.events();

    }

    events(){

        this.form.on('submit', this.submitForm.bind(this));
        
    }
    submitForm(event){

        event.preventDefault();

        const data = {
            first_name: this.form.find('input[name="first_name"]').val(),
            last_name: this.form.find('input[name="last_name"]').val(),
            email: this.form.find('input[name="email"]').val(),
            phone: this.form.find('input[name="phone"]').val(),

            company: this.form.find('input[name="company"]').val(),
            address_1: this.form.find('input[name="address_1"]').val(),
            address_2: this.form.find('input[name="address_2"]').val(),
            city: this.form.find('input[name="city"]').val(),
            parish: this.form.find('input[name="parish"]').val(),
            purpose: this.form.find('input[name="purpose"]').val(),
            location: this.form.find('input[name="location"]').val(),
            start_date: this.form.find('input[name="start_date"]').val(),
            end_date: this.form.find('input[name="end_date"]').val(),

            message: this.form.find('textarea[name="message"]').val(),
            nonce: jpfNK.nonce
        }

        this.disableForm();

        this.showprocessMessage();

        $.ajax({
            url: jpfNK.ajax_url,
            type: 'POST',
            data: {
                action: 'jpf_nk',
                formData: JSON.stringify(data)
            },
            success: (response) => {

                if(response.success){

                    this.successMessage(response.message);

                } else {

                    this.failedMessage(response.message);

                }

            },
            error: (xhr, status, error) => {
                console.error('Message send failure:', error);
                this.failedMessage('An error occurred. Please try again later.');
            }
        });

    }
    successMessage(message){

        new Modal({
            header:"Quote Request Submitted",
            alert:true,
            content: "Thank you for your request. A member of our team will respond within 24-48 hours.",
            confirm:{
                label:"Ok"
            }      
        })       
        this.removeprocessMessage();
        this.resetForm();

    }
    failedMessage(message){

        new Modal({
            header:"Quote Request Failed",
            alert:true,
            content: message,
            confirm:{
                label:"Ok"
            }      
        }) 
        this.removeprocessMessage();
        this.resetForm();
    }

}
export default NomadKitchens;